import { render, staticRenderFns } from "./DerivarConsulta.vue?vue&type=template&id=859376e2&scoped=true&"
import script from "./DerivarConsulta.vue?vue&type=script&lang=js&"
export * from "./DerivarConsulta.vue?vue&type=script&lang=js&"
import style0 from "./DerivarConsulta.vue?vue&type=style&index=0&id=859376e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "859376e2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VToolbarItems } from 'vuetify/lib'
import { VToolbarTitle } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VCard,
  VCardActions,
  VCardText,
  VDialog,
  VIcon,
  VSelect,
  VSpacer,
  VToolbar,
  VToolbarItems,
  VToolbarTitle,
})
